import { API_URL } from '../../../app-config/constants';
import type {
    CustomerHealthCompanyDto,
    CustomerHealthDto,
    CustomerHealthHRAdmin,
    IntegrationsDto,
    SupportDto,
    UsageAveragesDto,
} from '../../../types/CustomerHealthDto';
import { get } from '../request';

getCustomerHealthData.operation = 'READ';
export function getCustomerHealthData(): Promise<CustomerHealthDto> {
    return get(`${API_URL}/customer-health`);
}

export function getCustomerHealthDataCompany(companyId: string): Promise<CustomerHealthCompanyDto> {
    return get(`${API_URL}/customer-health/${companyId}`);
}

export function getUsage(companyId: string, start: string, end: string): Promise<UsageAveragesDto> {
    return get(`${API_URL}/customer-health/${companyId}/usage`, {
        getData: {
            start,
            end,
        },
    });
}

export function getUsageGraph(
    companyId: string,
    start: string,
    end: string
): Promise<({ week: string } & Record<string, number>)[]> {
    return get(`${API_URL}/customer-health/${companyId}/usage-graph`, {
        getData: {
            start,
            end,
        },
    });
}

export function getEngagementGraph(
    companyId: string,
    start: string,
    end: string
): Promise<({ week: string } & Record<string, number>)[]> {
    return get(`${API_URL}/customer-health/${companyId}/engagement-graph`, {
        getData: {
            start,
            end,
        },
    });
}

export function getHRAdmins(companyId: string): Promise<CustomerHealthHRAdmin[]> {
    return get(`${API_URL}/customer-health/${companyId}/hr-admins`);
}

export function getIntegrations(companyId: string): Promise<IntegrationsDto> {
    return get(`${API_URL}/customer-health/${companyId}/integrations`);
}

export function getSupport(companyId: string, start: string, end: string): Promise<SupportDto> {
    return get(`${API_URL}/customer-health/${companyId}/support`, {
        getData: {
            start,
            end,
        },
    });
}
